import React from 'react';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
      const handleBackToHome = () => {
            window.location.href = '/';
      };

      return (
            <div className="flex justify-center items-center h-screen bg-gray-100">
                  <div className="w-full max-w-md p-6 text-center bg-white shadow-lg rounded-2xl">
                        <XCircle className="text-red-500 w-16 h-16 mx-auto mb-4" />
                        <h1 className="text-2xl font-bold mb-2">Payment Failed</h1>
                        <p className="text-gray-600 mb-4">
                              Unfortunately, your transaction could not be completed. Please try again later.
                        </p>
                        <button
                              className="w-full bg-red-500 text-white py-2 rounded-md hover:bg-red-600"
                              onClick={handleBackToHome}
                        >
                              Back to Home
                        </button>
                  </div>
            </div>
      );
};

export default PaymentCancel;
